import { Box, styled } from '@mui/material'

export const WarningBox = styled(Box)<{ background: string }>(({ theme, background }) => ({
  background: background,
  fontSize: theme.typography.pxToRem(14),
  display: 'flex',
  padding: `${theme.spacing(1)} ${theme.spacing(4)}`,
  alignItems: 'center',
}))
